/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountCustomerBalanceViewProps } from './account-customer-balance';

export default (props: IAccountCustomerBalanceViewProps) => {
    const {
        heading,
        accountSectionHeading,
        creditSummarySectionHeading,
        accountLabels,
        accountValues,
        creditSummaryLabels,
        creditSummaryValues,
        homeButton,
        actions,
        requestStatementModal,
        availableCredit,
        balanceOwed,
        creditExcess
    } = props;

    return (
        <Node className='ms-account-customer-balance'>
            {heading}
            {requestStatementModal}
            {actions}
            {accountSectionHeading}
            <section className='ms-account-customer-balance__account'>
                {accountLabels}
                {accountValues}
            </section>
            {creditSummarySectionHeading}
            <section className='ms-account-customer-balance__credit-summary ms-account-customer-balance__summary-details'>
                {creditSummaryLabels}
                {creditSummaryValues}
                {availableCredit}
                {balanceOwed}
                {creditExcess}
            </section>
            {homeButton}
        </Node>
    );
};
